@if (browseOptions$ | async; as options) {
  <div class="layout-col full">
    <elder-table
      class="flex"
      [data]="data"
      [cleanUp]="true"
      matSort
      [interactionMode]="interactionMode"
      [selectionVisible]="selectionVisible"
      (itemClick)="onNodeClick($event)"
      (selectionSingleChange)="onSingleSelection($event)"
      [selectableEvaluatorFn]="isSelectableFn"
    >
      <elder-data-toolbar
        *elderTableToolbar
        [canRemove]="false"
        [canAdd]="canAdd"
        [canMore]="false"
        (requestNew)="onNewNode($event)"
      >
        <ng-template elderToolbarContent="left.actions">
          <div class="layout-row place-start-center gap-sm">
            <button mat-icon-button [disabled]="!canNavigateBack()" (click)="onNavigateBack()">
              <mat-icon>arrow_back</mat-icon>
            </button>
            <mat-form-field style="width: 100px" elderDense>
              <elder-select
                appFacilitySelect
                [displayPropertyResolver]="facilityDisplayResolverFn"
                [autoSelectFirst]="true"
                [isOptionDisabledFn]="isFacilityDisabledFn"
                valueAsId
                [ngModel]="facilityId"
                (entityIdUpdated)="onFacilityIdUpdated($event)"
              >
              </elder-select>
            </mat-form-field>
            <mat-form-field class="flex" elderDense>
              <input matInput type="text" name="browsePath" readonly [value]="options.browsePath" />
            </mat-form-field>
            <!--
            <elder-bread-crumbs class="flex"
              [rootIcon]="'business'"
              [root]="browseRoot$ | async"
              [path]="options.browsePath"
              (pathChange)="onBreadCrumbPathChanged($event)"
              >
            </elder-bread-crumbs>
            -->
          </div>
        </ng-template>
      </elder-data-toolbar>
      <!-- icon Column -->
      <ng-container matColumnDef="icon">
        <th mat-header-cell *matHeaderCellDef style="width: 30px" mat-sort-header="type"></th>
        <td
          mat-cell
          *matCellDef="let node"
          [matTooltip]="node.path + ' (' + ('storage.nodes.type.' + node.type | translate) + ')'"
        >
          <mat-icon
            [matBadge]="'!'"
            [matBadgeOverlap]="true"
            [matBadgeColor]="'primary'"
            [matBadgeSize]="'small'"
            [matBadgeHidden]="node.activated"
          >
            @if (node.type === StorageNodeType.Logical) {
              <span>border_clear</span>
            }
            @if (node.type === StorageNodeType.Physical) {
              <span>border_all</span>
            }
          </mat-icon>
        </td>
      </ng-container>
      <!-- number Column -->
      <ng-container matColumnDef="number">
        <th mat-header-cell *matHeaderCellDef style="width: 15%" mat-sort-header>
          {{ 'context.number' | translate }}
        </th>
        <td mat-cell *matCellDef="let node">{{ node.number }}</td>
      </ng-container>
      <!-- description Column -->
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'context.description' | translate }}
        </th>
        <td mat-cell *matCellDef="let node">{{ node.description }}</td>
      </ng-container>
      <!-- priority Column -->
      <ng-container matColumnDef="priority">
        <th mat-header-cell *matHeaderCellDef style="width: 10%" mat-sort-header>
          {{ 'context.priority' | translate }}
        </th>
        <td mat-cell *matCellDef="let node">{{ node.priority }}</td>
      </ng-container>
      <!-- actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef style="width: 10%"></th>
        <td mat-cell *matCellDef="let node">
          <button mat-icon-button elderStopEventPropagation (click)="onNavigateToNode(node)">
            <mat-icon>details</mat-icon>
          </button>
        </td>
      </ng-container>
    </elder-table>
  </div>
}
